import * as React from 'react';
import ChartRender from './ChartRender';
import { treemapRender } from './chartRender/treemapRender';

export default class TreemapChart extends React.Component {
    static indentify = 'treemap_chart';
    render() {
        return (
            <div className="full-height full-width">
                <ChartRender chartRender={treemapRender} {...this.props} />
            </div>
        );
    }
}
